/**
 * Media upload service with retry logic
 * Created for coach.kinastic.com
 */

import { BackendFactory } from './Http/BackendFactory';
import { v4 as uuid } from 'uuid';
import { Media, createMedia } from '../Model/Media/Media';
import { Retry } from '../Utils/Retry';

const MAX_RETRIES = 3;

class MediaServiceClass {
  /**
   * Upload a file to the media service with automatic retries
   * Uses /media/media endpoint
   */
  async uploadMedia(
    file: File,
    containerName?: string,
    onUploadProgress?: (progressEvent: any) => void,
  ): Promise<Media> {
    const suffix = file.name.split('.').pop() || 'jpg';
    const name = `${uuid()}`;
    const finalName = `${name}.${suffix}`;

    const formData = new FormData();
    formData.append('name', finalName);
    formData.append('file', file);

    if (containerName) {
      formData.append('containerName', containerName);
    }

    const uploadFn = async (): Promise<Media> => {
      const backend = await BackendFactory();
      const response = await backend.api.post('/media/media', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress,
      });
      return createMedia(response.data);
    };

    return Retry.tryTimes(uploadFn, MAX_RETRIES);
  }
}

export const MediaService = new MediaServiceClass();
